module.exports = ".imgLogin{width:100px}.errorTag .mat-card{background:#fc5252;color:#fff;font-size:15px}.errorTag i{color:#fff}\n"